<div class="container-box p-3">
  <p class="mb-0" *ngIf="group === null" i18n>Booking.com bathrooms cannot be managed here for this property type.</p>

  <app-loading-section *ngIf="isLoading && !form"></app-loading-section>

  <form *ngIf="form && group === groups.Home" [formGroup]="form">
    <ng-container formArrayName="bathrooms">
      <div *ngFor="let bathroom of bathrooms.controls; let i = index" [formGroupName]="i">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0"><ng-container i18n>Bathroom</ng-container> {{ i + 1 }}</h6>
          <button
            class="btn btn-secondary-danger btn-sm"
            (click)="bathrooms.removeAt(i)"
            [disabled]="form.disabled"
            type="button"
          >
            <i class="cs-icon cs-icon-trash"></i>
          </button>
        </div>
        <mat-radio-group formControlName="bathroom_type" class="d-flex gap-3 my-2">
          <mat-radio-button [value]="bathroomType.PRIVATE" i18n>Private</mat-radio-button>
          <mat-radio-button [value]="bathroomType.SHARED" i18n>Shared</mat-radio-button>
        </mat-radio-group>
        <mat-form-field2>
          <mat-label i18n>Bathroom Location</mat-label>
          <mat-select formControlName="bathroom_location">
            <mat-option [value]="null" i18n>Not specified</mat-option>
            <mat-option *ngFor="let location of allowedLocations[bathroom.value.bathroom_type]" [value]="location">
              {{ location | titleCase }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
        <div class="text-danger" *ngIf="bathroom.errors?.locationNotAllowed" i18n>
          This location is not allowed for this unit type.
        </div>
        <hr />
      </div>
    </ng-container>
    <p *ngIf="!bathrooms.length" i18n>This unit has no bathrooms.</p>
    <button
      class="btn btn-secondary-info"
      (click)="addBathroom()"
      [disabled]="form.disabled || bathrooms.length >= maxBathrooms"
      type="button"
    >
      <i class="far fa-plus"></i> <ng-container i18n>Add Bathroom</ng-container>
    </button>
  </form>

  <form *ngIf="form && group === groups.Hotel" [formGroup]="form">
    <h6 i18n>Private bathroom</h6>
    <div class="form-field-label mb-2" i18n>Just for use by guests in this room</div>
    <mat-radio-group formControlName="private_bathroom_state" class="d-flex gap-3 mb-2">
      <mat-radio-button [value]="facilityState.PRESENT" i18n>Yes</mat-radio-button>
      <mat-radio-button [value]="facilityState.MISSING" i18n>No</mat-radio-button>
    </mat-radio-group>
    <div
      *ngIf="form.value.private_bathroom_state === facilityState.PRESENT"
      formGroupName="private_bathroom_details"
      class="d-flex gap-3"
    >
      <mat-form-field2>
        <mat-label i18n>Bathroom Type</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="null" i18n>Not specified</mat-option>
          <mat-option *ngFor="let type of privateBathroomTypes" [value]="type">{{ type | titleCase }}</mat-option>
        </mat-select>
      </mat-form-field2>
      <mat-form-field2>
        <mat-label i18n>Bathroom Location</mat-label>
        <mat-select formControlName="location_type">
          <mat-option [value]="null" i18n>Not specified</mat-option>
          <mat-option *ngFor="let location of locationTypes" [value]="location">{{ location | titleCase }}</mat-option>
        </mat-select>
      </mat-form-field2>
      <mat-form-field2 *ngIf="form.value.private_bathroom_details?.location_type === locationOther">
        <mat-label i18n>Where is the bathroom located?</mat-label>
        <input matInput type="text" formControlName="location_other" />
      </mat-form-field2>
    </div>
    <hr />
    <h6 i18n>Shared bathroom</h6>
    <div class="form-field-label mb-2" i18n>Shared with guests from other rooms</div>
    <mat-radio-group formControlName="shared_bathroom_state" class="d-flex gap-3 mb-2">
      <mat-radio-button [value]="facilityState.PRESENT" i18n>Yes</mat-radio-button>
      <mat-radio-button [value]="facilityState.MISSING" i18n>No</mat-radio-button>
    </mat-radio-group>
    <ng-container
      *ngIf="
        form.value.private_bathroom_state === facilityState.PRESENT ||
        form.value.shared_bathroom_state === facilityState.PRESENT
      "
    >
      <hr />
      <mat-form-field2>
        <mat-label i18n>Number of bathrooms</mat-label>
        <input matInput type="number" formControlName="number_of_bathrooms" />
      </mat-form-field2>
      <div class="text-danger" *ngIf="form.errors?.bathroomCount as min" i18n>
        Number of bathrooms must be a whole number from {{ min }} to {{ maxBathrooms }}.
      </div>
    </ng-container>
  </form>
</div>
